import styled from 'styled-components';
import Container from '../Container';
import Typography from '../Typography';
export const RibbonStyled = styled(Container)(({ theme, color, variant = 'base', }) => {
    var _a, _b, _c, _d, _e, _f;
    return ({
        backgroundColor: (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.primary,
        color: (_d = (_c = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _c === void 0 ? void 0 : _c.background) === null || _d === void 0 ? void 0 : _d.default,
        ...color && {
            backgroundColor: (_e = theme === null || theme === void 0 ? void 0 : theme.colors[color]) === null || _e === void 0 ? void 0 : _e[variant],
            color: variant === 'dark' ?
                theme === null || theme === void 0 ? void 0 : theme.colors[color].contrastText
                :
                    (_f = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _f === void 0 ? void 0 : _f.text.primary,
        },
        padding: '8px 0',
        lineHeight: '1',
        alignItems: 'center',
        display: 'inline-flex',
        userSelect: 'none',
        width: '100%',
        justifyContent: 'center',
    });
});
export const RibbonText = styled(Typography).attrs({
    variant: 'overline',
})(({ theme, }) => ({
    color: 'inherit',
}));
//# sourceMappingURL=Ribbon.styles.js.map